import { render, staticRenderFns } from "./passTable.vue?vue&type=template&id=2e9aade5&scoped=true&"
import script from "./passTable.vue?vue&type=script&lang=js&"
export * from "./passTable.vue?vue&type=script&lang=js&"
import style0 from "./passTable.vue?vue&type=style&index=0&id=2e9aade5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9aade5",
  null
  
)

export default component.exports